module.exports = __webpack_public_path__ + "img/bg-5.cf607f61.jpg";